import Vue from 'vue'
import store from './store'
import router from './router'
import App from './App'
import Buefy from 'buefy'
import 'vue-multiselect/dist/vue-multiselect.min.css'

/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap')

Vue.use(Buefy, {
  defaultIconPack: 'fas'
})

// Development and production settings
Vue.config.productionTip = false
Vue.config.devtools = false
Vue.config.debug = false
Vue.config.silent = true

// Inititalize vue
const app = new Vue({
  store,
  router,
  render: h => h(App)
})

// validate #app if exist on html
if (document.querySelector('#app')) {
  app.$mount('#app')
}
